window.addEventListener("modulePanelAnchor", function(evt) {
  var a_module_panel = document.querySelectorAll('a[data-panel]:not(.listening)');
  Array.from(a_module_panel).forEach(function (el) {
    "use strict";
    var id = el.dataset.panel,
      href = el.getAttribute('href'),
      linked = document.querySelectorAll('.m6pn[id="' + id + '"]');
    el.classList.add('listening');

    if (linked.length) {
      el.setAttribute('aria-haspopup', true);
      el.setAttribute('aria-controls', id);
      if (el.tagName.toLowerCase() === 'a') {
        el.addEventListener('click', function (e) {
          if (id == 'cart') {
            e.preventDefault();
            ajaxCart.load();
          } else {
            openPanel(id);
            if (!href.includes('#')) {
              e.preventDefault();
            }
          }
        });
        el.addEventListener('keyup', function (e) {
          if (e.key === ' ') {
            e.preventDefault();
            if (id == 'cart') {
              ajaxCart.load();
              return;
            } else {
              openPanel(id);
            }
          }
        });
      }
    }
  });
});

function sendProductAddedToCartEvent(response) {
  var countries = {
    'elektor.com': 'INT',
    'elektor.fr': 'FR',
    'elektor.nl': 'NL',
    'elektor.de': 'DE',
    'www.elektor.com': 'INT',
    'www.elektor.fr': 'FR',
    'www.elektor.nl': 'NL',
    'www.elektor.de': 'DE'
  };

  var code = countries[window.location.hostname];
  var productId = 'Shopify_' + code + '_' + response.id;
  klaviyo.push(["track", "Added to Cart", {
   "AddedItemProductName": response.product_title,
   "AddedItemProductID": productId,
   "AddedItemSKU": productId,
   "AddedItemCategories": [],
   "AddedItemImageURL": response.image,
   "AddedItemURL": response.url,
   "AddedItemPrice": response.line_price / 100,
   "AddedItemQuantity": response.quantity,
   "CheckoutURL": window.location.origin + '/cart',
 }]);
}
